import React, { useState } from "react";
import NoteLogicFormField from "./NoteLogicFormField";

const AddNoteLogic = () => {


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Note Logics", url: "/note-logics" },
        { content: "Add Note Logic", url: "" }
    ]
    )

    return (
        <>

            <NoteLogicFormField crumbs={crumbs} title={"Add Note Rule"} btnText={"Add"} />

        </>
    )


}
export default AddNoteLogic;